import script from "./EmployeeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeCard.vue?vue&type=style&index=0&id=022b678e&lang=scss"

const __exports__ = script;

export default __exports__